import React, { useContext } from 'react'
import clsx from 'clsx'
import { Drawer, List, IconButton, makeStyles, Divider } from '@material-ui/core'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import MenuIcon from '@material-ui/icons/Menu'
import { MainListItems, OrdersList, ProductList, BrandList } from './listItems'
import { ReactComponent as Logo } from '../../assets/logo-dark.svg'
import { LayoutContext } from '../../context/LayoutContext'
import { drawerWidth } from '../../types/Layout'

const useStyles = makeStyles((theme) => ({
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '15px 2rem 0 5px',
    ...theme.mixins.toolbar
  },
  logoutIcon: {
    position: 'absolute',
    bottom: 0
  },
  drawerPaper: {
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9)
    }
  },
  menuButtonHidden: {
    display: 'none'
  },
  menuButton: {
    marginRight: 8
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}))

export default function Menu (): JSX.Element {
  const classes = useStyles()
  const { layout, setLayout } = useContext(LayoutContext)

  const handleDrawerOpen = () => {
    setLayout({
      isMenuOpen: true
    })
  }
  const handleDrawerClose = () => {
    setLayout({
      isMenuOpen: false
    })
  }

  return (
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper, !layout.isMenuOpen && classes.drawerPaperClose)
        }}
        open={layout.isMenuOpen}
        PaperProps={{ elevation: 3 }}>
        <div className={classes.toolbarIcon}>
          <IconButton
            onClick={handleDrawerClose}
            className={clsx(classes.menuButton, !layout.isMenuOpen && classes.menuButtonHidden)}>
            <ChevronLeftIcon />
          </IconButton>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            className={clsx(classes.menuButton, layout.isMenuOpen && classes.menuButtonHidden)}>
            <MenuIcon />
          </IconButton>
          <Logo style={{ height: '2.8rem' }} />
        </div>
        <br />
        <List>
          <MainListItems drawerEffect={handleDrawerClose} />
          <Divider className={classes.divider} />
          <OrdersList drawerEffect={handleDrawerClose} />
          <Divider className={classes.divider} />
          <BrandList drawerEffect={handleDrawerClose} />
          <Divider className={classes.divider} />
          <ProductList drawerEffect={handleDrawerClose} />
        </List>
      </Drawer>
  )
}
